import { api } from '@/utils/client';

const state = {
	terms: []
}

// actions
const actions = {
	async fetchTermsInCategory(context, params = {}) {
		try {
			let response = await api.get('/terms', {params: params});
			context.commit('fetchTerms', response.data);
			return response;
		} catch (e) { console.log(e); throw e; }
	},
}
// mutations
const mutations = {
	fetchTerms(state, data) {
		state.terms = data;
	},
}

export default {
	state,
	actions,
	mutations
}
